import React from "react"
import styled from "styled-components"
import Title from "../Title"

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component"
import "react-vertical-timeline-component/style.min.css"

import { MdSchool, MdLocationOn } from "react-icons/md"
// MdComputer
function Education() {
  return (
    <Container className="section">
      <Title title="education" />
      <VerticalTimeline animate={false}>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{
            background: "rgba(255, 250, 243,0.89",
            color: "#444",
          }}
          contentArrowStyle={{
            borderRight: "10px solid rgba(255, 250, 243,0.8)",
          }}
          date="2018 - present"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#FFF" }}
          icon={<MdSchool />}
        >
          <h3 className="vertical-timeline-element-title">Web Development</h3>
          <h4 className="vertical-timeline-element-subtitle">
            {" "}
            React , Redux ,Gatsby,Graphql,Express
          </h4>
          <p>
            {" "}
            <MdLocationOn /> Online
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2018"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<MdSchool />}
        >
          <h3 className="vertical-timeline-element-title">Master's Degree</h3>
          <h4 className="vertical-timeline-element-subtitle">
            Computer and Communication Network Engineering
          </h4>
          <p>
            <MdLocationOn /> Politecnico Di Torino, Italy
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2010"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<MdSchool />}
        >
          <h3 className="vertical-timeline-element-title">Bachelor Degree </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Information Technology
          </h4>
          <p>
            <MdLocationOn />
            Jimma University , Ethiopia
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2006"
          iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
          icon={<MdSchool />}
        >
          <h3 className="vertical-timeline-element-title">Diploma</h3>
          <h4 className="vertical-timeline-element-subtitle">Mathematics</h4>
          <p>
            {" "}
            <MdLocationOn />
            Jimma University , Ethiopia
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </Container>
  )
}

export default Education

export const Container = styled.section`
  background: ${({ theme }) => theme.educationBackground};
  padding: 5rem 0;
`
